(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui/svg/assets/javascripts/shared.js') >= 0) return;  svs.modules.push('/components/tb-ui/svg/assets/javascripts/shared.js');
"use strict";



var svs = svs || {};
(function (svs) {
  'use strict';

  svs.tb_ui = svs.tb_ui || {};
  svs.tb_ui.svg = svs.tb_ui.svg || {};
  var isServerSide = typeof exports === 'object',
    config;
  if (isServerSide) {
    const trinidad = require('@svenskaspelab/trinidad-core').core;
    config = trinidad.config;
  } else {
    config = {
      options: svs.core.config.data.svsconfig
    };
  }
  const path = '/images/tb-ui/svg/',
    cdn = config.options && config.options.cdn ? config.options.cdn : '',
    hashedSvgs = {
      'kungkeno': 'kungkeno-8945c39f18d534ec87622f8b95fe408b14fcfe9e.svg',
      'kungkeno-outline': 'kungkeno-outline-49c44c615666eb056200ea650a674e21760e81ee.svg',
      'skrap': 'skrap-b6060cbb061a97f2e79e38506aa4e27f421ff8c8.svg',
      'skrap-inverted': 'skrap-inverted-6d3aa84f2c5f50ea1556d9c6ba93cdd824311de6.svg',
      'star': 'star-81c2fd247fb9878484ab3d504fbb28ffd9d5465c.svg',
      'star-outline': 'star-outline-718f96307ed470ee325d107774dfca88dc7f76d3.svg',
      'star-outline-100': 'star-outline-100-a6976e7347fe2af784ac736b58451dff55ce13ab.svg',
      'star-white': 'star-white-76fa5aaaef0f0cf49e9843a9847c765991053186.svg',
      'star-white-outline': 'star-white-outline-df0879ad2131ff6382119d96577f22822a37661c.svg',
      'star-white-outline-100': 'star-white-outline-100-52b3733b26560cf3ef33d1f35506cf4ae3a62eb2.svg'
    };
  svs.tb_ui.svg.getSVG = function (svg, size, inline) {
    let hashedStr = svg;
    if (hashedSvgs[hashedStr] && size > 0) {
      hashedStr = hashedSvgs[hashedStr + '-' + size] ? hashedStr + '-' + size : hashedStr;
    }
    if (inline) {
      const request = new XMLHttpRequest();
      request.open('GET', cdn + path + hashedSvgs[hashedStr], false);
      request.send(null);
      if (request.status === 200) {
        return request.responseText;
      }
    } else {
      return hashedSvgs[hashedStr] ? cdn + path + hashedSvgs[hashedStr] : false;
    }
  };

  if (typeof exports === 'object') {
    module.exports = svs.tb_ui.svg;
  }
})(svs);

 })(window);